import { SUBSCRIPTIONS_GET_BY_SUBSCRIBER } from 'apiRoutes';
import ApplicationCell from 'components/subscription/ApplicationCell';
import {
	PermissionSet,
	Subscription,
	SubscriptionStatus,
	SubscriptionType,
} from 'domain/subscription/interfaces/Subscription';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

const AccountTrialsCell: FunctionComponent<{
	accountId: string;
	statuses?: SubscriptionStatus[];
	faded?: boolean;
	iconsOnly?: boolean;
}> = ({
	accountId,
	statuses = [SubscriptionStatus.Active],
	faded = false,
	iconsOnly = false,
}) => {
	const { data: subscriptions } = useGetOnMount<Subscription[]>(
		`${SUBSCRIPTIONS_GET_BY_SUBSCRIBER}?subscriberId=${accountId}`,
	);

	const trials = subscriptions?.filter(
		(subscription) => subscription.type == SubscriptionType.Trial,
	);
	const statusFilteredTrials = trials?.filter((trial) =>
		statuses.includes(trial.status),
	);

	if (!statusFilteredTrials) return null;

	const permissionSetsWithActiveTrial = statusFilteredTrials.reduce(
		(acc, trial) => {
			Object.entries(trial.applicationPermissions).forEach(
				([appId, permissionSet]) => {
					acc[appId] = { ...acc[appId], ...permissionSet };
				},
			);
			return acc;
		},
		{} as Record<string, PermissionSet>,
	);

	return (
		<StyledOverlay $faded={faded}>
			<ApplicationCell
				permissionSets={permissionSetsWithActiveTrial}
				iconsOnly={iconsOnly}
			/>
		</StyledOverlay>
	);
};

const StyledOverlay = styled.div<{ $faded?: boolean }>`
	opacity: ${({ $faded }) => ($faded ? 0.5 : 1)};
`;

export default AccountTrialsCell;
